var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41016 19.4054H6.82416L16.1382 10.0914L14.7242 8.67736L5.41016 17.9914V19.4054ZM21.4102 21.4054H3.41016V17.1624L16.8452 3.72736C17.0327 3.53989 17.287 3.43457 17.5522 3.43457C17.8173 3.43457 18.0716 3.53989 18.2592 3.72736L21.0882 6.55636C21.2756 6.74388 21.3809 6.99819 21.3809 7.26336C21.3809 7.52852 21.2756 7.78283 21.0882 7.97036L9.65316 19.4054H21.4102V21.4054ZM16.1382 7.26336L17.5522 8.67736L18.9662 7.26336L17.5522 5.84936L16.1382 7.26336Z"
  })));
};
export default SvgEdit;